export default __webpack_public_path__ + "static/session-do-dark-7e8fd7f6a89992420a261e2658f381ff.png";